componentRegistryInstance.register('text', 'edit', 'hrd.components.form.TextComponent');
componentRegistryInstance.register('text', 'read', 'hrd.components.form.TextComponent');

hrd.components.form.TextComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.TextComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},

	enhanceEditField: function(field, id, klass) {
		this._super(field, id, klass);

		/* test if configured as autocomplete */
		let autocomplete = field.data('autocomplete');
		if (autocomplete != undefined) {
			let autocompleteInfo = $.evaluate(autocomplete);
			if (autocomplete === true) {
				autocompleteInfo = {
					source: field.data('autocomplete-source') !== undefined,
					data: field.data('autocomplete-source-data') !== undefined,
					select: field.data('autocomplete-select') !== undefined,
					change: field.data('autocomplete-change') !== undefined,
					minLength: 2
				};
			}
			field.after('<span class="ajax-indicator"></span>');

			const usingChromaFlow = $(field).usingChromaFlow();
			const toolbox = new hrd.Toolbox();

			if (autocompleteInfo.source || autocompleteInfo.data) {
				let css = autocompleteInfo.css;
				if (dashboardInstance.isDoubleSize()) {
					css = (css ? ' ' : '') + 'items-2x';
				}
				field.autocomplete({
					minLength: autocompleteInfo.minLength || 2,
					source: this.getAutoCompleteSource(field, autocompleteInfo),
					select: this.getAutoCompleteSelect(field, autocompleteInfo),
					change: this.getAutoCompleteChange(field, autocompleteInfo),
					focus: this.getAutoCompleteFocus(field, autocompleteInfo),
					css: css || '',

					create: function() {
						if(!usingChromaFlow) return;

						const autocompleteData = $(field).data('autocomplete');

						if(!autocompleteData) return;

						const $menu = toolbox.get('menu.activeMenu', autocompleteData);

						if(!$menu.exists()) return;

						$menu
							.attr('data-state', 'closed')
							.addClass('closed popover command')
							.prop('style')
							.setProperty('--min-width', '16rem');
					},
					open: function() {
						if(!usingChromaFlow) return;

						const autocompleteData = $(field).data('autocomplete');

						if(!autocompleteData) return;

						const $menu = toolbox.get('menu.activeMenu', autocompleteData);

						if(!$menu.exists()) return;

						$menu
							.removeClass('closed')
							.attr('data-state', 'open');
					},
					close: function(event) {
						if(!usingChromaFlow) return;

						const autocompleteData = $(field).data('autocomplete');

						if(!autocompleteData) return;

						const $menu = toolbox.get('menu.activeMenu', autocompleteData);

						if(!$menu.exists()) return;

						$menu
							.attr('data-state', 'closed')
							.addClass('closed')
							.css({
								top: 'unset',
								bottom: 'unset',
								left: 'unset',
								right: 'unset',
							});
					},
				});
			}
		}
	},

	getAutoCompleteSource: function(field, autocompleteInfo) {
		var fnName, reference = this.settings.reference;
		if (autocompleteInfo.source) {
			// never used for the moment
			fnName = field.functionCase('autocomplete-source');
			if (reference && typeof reference[fnName] === 'function') {
				return function(request, response) {
					return reference[fnName].call(reference, field, request, response);
				};
			} else {
				if (reference) {
					console.log(`Please, add "${fnName}: function(field, request, response){}" to "${reference._FULL_}" as autocomplete "source" function`);
				}
				return function(request, response) {
					return field.triggerHandler('autocomplete-source')(request, response);
				};
			}
		} else if (autocompleteInfo.data) {
			fnName = field.functionCase('autocomplete-data');
			var sourceData;
			if (reference && typeof reference[fnName] === 'function') {
				sourceData = reference[fnName].call(reference, field);
			} else {
				if (reference) {
					console.log(`Please, add "${fnName}" function to "${reference._FULL_}" as autocomplete "data" function`);
				}
				sourceData = field.triggerHandler('autocomplete-source-data');
			}
			return function(request, response) {
				if (sourceData != undefined) {
					sourceData.value = request.term;
					$.ajax({
						url: hrd.globals.autocompleteURI,
						dataType: "json",
						method: 'POST',
						data: sourceData
					}).then((data) => {
						response($.map(data.list, (item) => {
							return {
								label: item.label,
								value: item.label,
								id: item.id,
								desc: item.description,
								originator: item.originatorField
							};
						}));
					});
				}
			}
		} else {
			$.noop;
		}
	},
	getAutoCompleteSelect: function(field, autocompleteInfo) {
		if (autocompleteInfo.select) {
			let formInstance = this.getFormInstance();
			let fnName = field.functionCase('autocomplete-select');
			let reference = this.settings.reference;
			return function(event, ui) {
				field.data('selected-id', ui.item.id);
				if (reference && typeof reference[fnName] === 'function') {
					reference[fnName].call(reference, ui.item, field, formInstance);
				} else {
					if (reference) {
						console.log(`Please, add "${fnName}" function to "${reference._FULL_}" as autocomplete "select" function`);
					}
					field.triggerHandler('autocomplete-select', { item: ui.item, field: field, form: formInstance });
				}
			}
		} else {
			return function(_, ui) {
				field.data('selected-id', ui.item);
			}
		}
	},
	getAutoCompleteFocus: function(field, autocompleteInfo) {
		if (autocompleteInfo.focus) {
			let formInstance = this.getFormInstance();
			let fnName = field.functionCase('autocomplete-focus');
			let reference = this.settings.reference;
			return function(event, ui) {
				if (reference && typeof reference[fnName] === 'function') {
					reference[fnName].call(reference, ui.item, field, formInstance);
				} else {
					if (reference) {
						console.log(`Please, add "${fnName}" function to "${reference._FULL_}" as autocomplete "focus" function`);
					}
					field.triggerHandler('autocomplete-focus', { item: ui.item, field: field, form: formInstance });
				}
			}
		}
	},
	getAutoCompleteChange: function(field, autocompleteInfo) {
		if (autocompleteInfo.change) {
			let formInstance = this.getFormInstance();
			let fnName = field.functionCase('autocomplete-change');
			let reference = this.settings.reference;
			return function(event, ui) {
				if (!ui.item) {
					field.removeData('selected-id');
				}
				if (reference && typeof reference[fnName] === 'function') {
					reference[fnName].call(reference, ui.item, field, formInstance);
				} else {
					if (reference) {
						console.log(`Please, add "${fnName}" function to "${reference._FULL_}" as autocomplete "change" function`);
					}
					field.triggerHandler('autocomplete-change', { item: ui.item, field: field, form: formInstance });
				}
			}
		} else {
			return function(event, ui) {
				if (!ui.item) {
					field.removeData('selected-id');
				}
			}
		}
	},

	setReadOnlyField: function(field, value, object, options) {
		this._super(field, value, object, options);
		this.applyTooltipIfNeeded(field);
	},
});